import "./productadtemplate.scss";
import Button from "../../../core/button/button";

const ProductAdTemplate = () => {
    return (
        <div className="Product-Ad-Template">
            <div className="Product-Ad-Template-Header">
                <div className="d-flex align-items-center justify-content-between pt-2 gap-2">
                    <span> پیشنهاد ویژه دیجی استایل</span>
                    <div className="Ad-Logo-Container">
                        <img src={require("../../../assets/images/Logo2.png")} alt="" className="img-fluid"/>
                    </div>
                </div>
                <img src={require("../../../assets/images/photos/AdTemplate3.png")} alt=""
                     className="img-fluid Product-Ad-Template-Image"/>
            </div>
            <div className="Product-Ad-Template-Body">
                <div className="border-bottom text-start">
                    <h6 className="text-end">کیف مجلسی روشونی قرمز مدل Dior</h6>
                    <s className="text-muted">تومان 450,000</s>&nbsp;&nbsp;&nbsp;<span className="text-success">تومان 450,000</span>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                    <span className="pt-2" style={{color: '#162198'}}> تخفیف ۲۰ درصدی  عید نوروز</span>
                    <Button type={"primary"} action={() => {
                    }} responsive={true}>کلیک کنید</Button>
                </div>
            </div>
        </div>
    );
}

export default ProductAdTemplate;